// extracted by mini-css-extract-plugin
export default {"content":"layout_content__oqinZ","all":"layout_all__DM6Xo","m_sidebar":"layout_m_sidebar__vkf-r","open":"layout_open__ymA8v","margin":"layout_margin__YBmpI"};